import BrightcoveVideo from "@atoms/players/BrightcoveVideo";
import { ArticleIndividualMediaProps } from "@pages/Article/components/ArticleMainMedia/utils/types";

/**
 * ArticleBrightcoveMedia component that renders a Brightcove video player
 * for the main media of an article.
 */
const ArticleBrightcoveMedia = ({
  media,
}: ArticleIndividualMediaProps): React.ReactElement => {
  if (!media.brightcoveId) return <></>;

  return <BrightcoveVideo className="w-full" videoId={media.brightcoveId} />;
};

export default ArticleBrightcoveMedia;
